var map = {
	"./A1.gif": "e8d3",
	"./A2.gif": "7326",
	"./A3.gif": "f140",
	"./A4.gif": "9c36",
	"./A5.gif": "c663",
	"./B3.gif": "c16f",
	"./B4.gif": "07b4",
	"./B5.gif": "ea93",
	"./C3.gif": "c8ba",
	"./C4.gif": "5158",
	"./C5.gif": "b3e19",
	"./D3.gif": "b7f0",
	"./D4.gif": "ec23",
	"./D5.gif": "ab9c",
	"./E3.gif": "1570",
	"./E4.gif": "4641",
	"./E5.gif": "fd78",
	"./F3.gif": "f233",
	"./G2.gif": "796e",
	"./G3.gif": "c45c",
	"./G4.gif": "19e7",
	"./G5.gif": "2b7e",
	"./H3.gif": "fad6",
	"./H4.gif": "c86b",
	"./H5.gif": "079e",
	"./I4.gif": "923d",
	"./I5.gif": "4dd3",
	"./J3.gif": "16eb",
	"./J4.gif": "b336",
	"./J5.gif": "c252",
	"./Z3.gif": "2823",
	"./tk.gif": "26a9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5f37";